// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Abel);"]);
// Module
exports.push([module.id, ".wrapper {\n  display: flex;\n  justify-content: space-between; }\n\n.right {\n  display: flex;\n  flex-direction: column;\n  min-width: 300px;\n  width: 100%;\n  margin-left: 200px;\n  z-index: 0;\n  transition: margin-left 0.25s ease 0s; }\n\n.no-side {\n  margin-left: 0px;\n  transition: margin-left 0.25s ease 0s; }\n", ""]);
// Exports
module.exports = exports;
